import { render } from "./ProgramListView.vue?vue&type=template&id=6e346dae&scoped=true&ts=true"
import script from "./ProgramListView.vue?vue&type=script&lang=ts"
export * from "./ProgramListView.vue?vue&type=script&lang=ts"

import "./ProgramListView.vue?vue&type=style&index=0&id=6e346dae&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e346dae"]])

export default __exports__